import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { IChargingMethodRepository } from '../entities/IChargingMethodRepository';
import { ChargingMethod } from '../entities';
import { chargingMethodDTOToChargingMethodAdapter } from './';

class ChargingMethodRepositoryImpl implements IChargingMethodRepository {
  constructor() {
    this.GetChargingMethods = this.GetChargingMethods.bind(this);
  }

  GetChargingMethods(): Promise<ChargingMethod[]> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/transfers/parameters/charging-methods',
        dataAdapter: chargingMethodDTOToChargingMethodAdapter,
      },
    });
  }
}

export { ChargingMethodRepositoryImpl };
